import { getCCPAAccess } from '@/helpers/getCCPAAccess';
import { USP_STRINGS } from '../constants';
import { isGpcApplicable } from './isGpcApplicable';

/**
 * Builds the IAB US Privacy ("USP") string for the __uspapi stub.
 *
 * - CCPA user, GPC opt-out           → '1YYN' (notice given, opted out of sale)
 * - CCPA user, no GPC opt-out        → '1YNN'
 * - non-CCPA region / geo unresolved → '1---'
 *
 * Computed lazily on each __uspapi call so it reflects geo once the async
 * lookup resolves.
 */
export const getUspString = (): string => {
	if (!getCCPAAccess()) {
		return USP_STRINGS.NOT_APPLICABLE;
	}

	return isGpcApplicable() ? USP_STRINGS.OPT_OUT : USP_STRINGS.NO_OPT_OUT;
};
